import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children, headerVariant = 'solid' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#contenido'
                className='sr-only z-[60] rounded-full bg-white px-5 py-3 text-sm font-bold text-brand-700 shadow-lg focus:not-sr-only focus:fixed focus:top-4 focus:left-4'
            >
                Saltar al contenido
            </a>

            <SiteHeader variant={headerVariant} />

            <main id='contenido' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
